module.exports = __webpack_public_path__ + "static/media/hardhat.64828f19.png";